'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common_gen = require('../common/common.gen.cjs');

"use strict";
const defaultTableFieldOptions = {
  align: "auto",
  inspect: false,
  wrapHeaderText: false,
  cellOptions: {
    type: common_gen.TableCellDisplayMode.Auto
  }
};
var LoadingState = /* @__PURE__ */ ((LoadingState2) => {
  LoadingState2["NotStarted"] = "NotStarted";
  LoadingState2["Loading"] = "Loading";
  LoadingState2["Streaming"] = "Streaming";
  LoadingState2["Done"] = "Done";
  LoadingState2["Error"] = "Error";
  return LoadingState2;
})(LoadingState || {});

exports.AxisColorMode = common_gen.AxisColorMode;
exports.AxisPlacement = common_gen.AxisPlacement;
exports.BarAlignment = common_gen.BarAlignment;
exports.BarGaugeDisplayMode = common_gen.BarGaugeDisplayMode;
exports.BarGaugeNamePlacement = common_gen.BarGaugeNamePlacement;
exports.BarGaugeSizing = common_gen.BarGaugeSizing;
exports.BarGaugeValueMode = common_gen.BarGaugeValueMode;
exports.BigValueColorMode = common_gen.BigValueColorMode;
exports.BigValueGraphMode = common_gen.BigValueGraphMode;
exports.BigValueJustifyMode = common_gen.BigValueJustifyMode;
exports.BigValueTextMode = common_gen.BigValueTextMode;
exports.ComparisonOperation = common_gen.ComparisonOperation;
exports.ConnectionDirection = common_gen.ConnectionDirection;
exports.DataTopic = common_gen.DataTopic;
exports.DirectionDimensionMode = common_gen.DirectionDimensionMode;
exports.FrameGeometrySourceMode = common_gen.FrameGeometrySourceMode;
exports.GraphDrawStyle = common_gen.GraphDrawStyle;
exports.GraphGradientMode = common_gen.GraphGradientMode;
exports.GraphThresholdsStyleMode = common_gen.GraphThresholdsStyleMode;
exports.GraphTransform = common_gen.GraphTransform;
exports.HeatmapCalculationMode = common_gen.HeatmapCalculationMode;
exports.HeatmapCellLayout = common_gen.HeatmapCellLayout;
exports.LegendDisplayMode = common_gen.LegendDisplayMode;
exports.LineInterpolation = common_gen.LineInterpolation;
exports.LogsDedupStrategy = common_gen.LogsDedupStrategy;
exports.LogsSortOrder = common_gen.LogsSortOrder;
exports.PercentChangeColorMode = common_gen.PercentChangeColorMode;
exports.ResourceDimensionMode = common_gen.ResourceDimensionMode;
exports.ScalarDimensionMode = common_gen.ScalarDimensionMode;
exports.ScaleDimensionMode = common_gen.ScaleDimensionMode;
exports.ScaleDirection = common_gen.ScaleDirection;
exports.ScaleDistribution = common_gen.ScaleDistribution;
exports.ScaleOrientation = common_gen.ScaleOrientation;
exports.SortOrder = common_gen.SortOrder;
exports.StackingMode = common_gen.StackingMode;
exports.TableCellBackgroundDisplayMode = common_gen.TableCellBackgroundDisplayMode;
exports.TableCellDisplayMode = common_gen.TableCellDisplayMode;
exports.TableCellHeight = common_gen.TableCellHeight;
exports.TableCellTooltipPlacement = common_gen.TableCellTooltipPlacement;
exports.TextDimensionMode = common_gen.TextDimensionMode;
exports.TooltipDisplayMode = common_gen.TooltipDisplayMode;
exports.VariableFormatID = common_gen.VariableFormatID;
exports.VisibilityMode = common_gen.VisibilityMode;
exports.VizOrientation = common_gen.VizOrientation;
exports.defaultLineStyle = common_gen.defaultLineStyle;
exports.defaultOptionsWithTimezones = common_gen.defaultOptionsWithTimezones;
exports.defaultReduceDataOptions = common_gen.defaultReduceDataOptions;
exports.defaultTableFooterOptions = common_gen.defaultTableFooterOptions;
exports.defaultTableOptions = common_gen.defaultTableOptions;
exports.defaultTimeZone = common_gen.defaultTimeZone;
exports.defaultVizLegendOptions = common_gen.defaultVizLegendOptions;
exports.LoadingState = LoadingState;
exports.defaultTableFieldOptions = defaultTableFieldOptions;
//# sourceMappingURL=common.types.cjs.map
